<template>
  <div class="card mb-3">
    <div class="card-header"
       style="color: #2c3e50; text-align: left">
        <strong style="font-size: 22px">Data Creation process</strong>
    </div>
    <div class="card-body" style="text-align: left">
      Data Creation is the task of creating data including physical commonsense knowledge.<br/>
      The goal of Data Creation is to construct dataset with physical commonsense by making <B>two QA Data</B> with <B> one question-correct pair</B>. <br/>
      The process is illustrated as follows:
      <br/><br/>
      <img alt="creation process" src="./../assets/whole_creation.png" style="width: 100%; margin-top: 10px;">
      <br/>
    </div>
  </div>
</template>

<script>
export default {
  name: "Overview.vue"
}
</script>

<style scoped>

</style>